import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import Typography from '../../../Typography'
import Icon from '../../../Icon';
import RootRef from '@material-ui/core/RootRef';

const styles = theme => ({

  root_list_item: {
    cursor: "pointer",
    whiteSpace:'nowrap',
    minWidth:0,
    padding: `${theme.margins.xs}px ${theme.margins.xs + 1}px`,
    '&:hover': {
      background: theme.palette.lightGrey,
    },
  },
  selected: {
    fontWeight: theme.fontWeight.bold,
  },
  selected_icon_container: {
    margin: `-2px auto auto ${theme.margins.xs}px`,
    color: theme.palette.hylyBlue
  },
  expand_icon_container: {
    margin:'0 0 0 auto',
  },
  typography: {
    whiteSpace:'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});


const ListItemComponent = ({
  classes,
  item,
  search_value,
  selected_value,
  onSelect,
  selected_icon_type,
  is_expanded,
  expand_icon_type,
  default_selected,
  className
}) => {

  const splitted_item = React.useMemo(() => {
    if (!search_value) { return [item.name]; }
    return item.name
          .replace(RegExp(search_value,"gi"), (...args) => {
            const o = args[0], i = args[args.length - 2];
            return i === 0
              ? `${o}__`
              : i === item.name.length - 1
              ? `__${o}`
              : `__${o}__`;
          })
          .split('__');
  },[item.name, search_value]);

  React.useEffect(() => {
    if (default_selected && !selected_value) {
       onSelect({}, item);
    }
  },[selected_value, default_selected])

  return (
      <ListItem
         onClick = { e => onSelect(e, item) }
         selected = {selected_value === item.id}
         classes = {{
           root: classes.root_list_item + (className ? ` ${className}`: ''),
           selected:  classes.selected
         }}
         name = {item.name}
         id = {item.id}
      >
        <Typography
           type = {"body1"}
           className = {classes.typography}
           color = {
             selected_value && selected_value === item.id
             ? "hylyBlue"
             :"darkBlack"
           }
         >
          {
             splitted_item.map((o,idx) => {
               const typed = Boolean(search_value) && Boolean(o) && RegExp(`${search_value}`,"gi").test(o);
               return typed
               ? <b key = {`simple-list-${o}-${idx}`}>{o}</b>
               : <React.Fragment key = {`simple-list-${o}-${idx}`}>{o}</React.Fragment>
             }
           )
         }
         </Typography>
         {
           Boolean(is_expanded)
           ? <ListItemIcon className = {classes.expand_icon_container}>
               <Icon type = {expand_icon_type} />
             </ListItemIcon>
           : null
         }
      </ListItem>
  )
}

ListItemComponent.propTypes = {
  classes: PropTypes.object,
  item: PropTypes.shape({
    id:PropTypes.string,
    name:PropTypes.string,
    region:PropTypes.string
  }),
  search_value: PropTypes.string,
  selected_value: PropTypes.string,
  onSelect: PropTypes.func,
  selected_icon_type: PropTypes.string,
  is_expanded: PropTypes.bool,
  expand_icon_type: PropTypes.string
}

ListItemComponent.defaultProps = {
  selected_icon_type: "icon-check-single"
}
export default React.memo(withStyles(styles)(ListItemComponent));
